export const renderImage = (nameIMG) => {
  if (!nameIMG) return null;
  
  try {
    const image = `${process.env.PUBLIC_URL}/assets/${nameIMG}.png`;
    return (
      <div className="flex h-[100%] w-[8%]  content-center items-center  justify-center m-auto bg-[#F4F4F4]">
        <div className="h-[55px] w-[55px] border-[#D9D9D9] border-solid border-[2px] rounded-[50%] bg-[#ffffff] overflow-hidden">
        <img
          src={image}
          style={{ 
            maxHeight: "100%", 
            maxWidth: "100%", 
            height: "100%", 
            width: "100%",
            margin: "auto",
            paddingTop:"3px",
            objectFit: "contain"
          }}
          title={nameIMG}
          alt={nameIMG}
        />
        </div>
      </div>
    );
  } catch {
    return null;
  }
}; 
const nameIMG = {
  "אבי דואניס": "Avi Duanis",
  "ריי דואניס":"Roy Duanis",
  "נינה":"נינה",
  "אבי אולמן":"אבי אולמן",
};

export const renderImageStorage = (IMG) => {
  if (!IMG) return null;
  try {
    const image = `${process.env.PUBLIC_URL}/assets/${nameIMG[IMG]}.png`;
    return (
      <div className="h-[100%] w-[7%] content-center">
        <img
          src={image}
          style={{ height: "55px", margin: "auto" }}
          title={nameIMG}
          alt={nameIMG}
        />
      </div>
    );
  } catch {
    return null;
  }
}; 

export const renderStatusImage = (nameIMG) => {
  try {
    const image = `${process.env.PUBLIC_URL}/assets/${nameIMG}.png`||'';
    if(image!=null){
      return <div className="h-[100%]  content-center">
      <img
        src={image}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt={nameIMG}
        title={nameIMG}
      />
    </div>
    }
   
  } catch {
    return <div className="h-[100%] w-[20%] content-center">{nameIMG}</div>;
  }
 
};

export const renderLogo = (nameIMG) => {
  if (!nameIMG) return null;
  
  const image = `${process.env.PUBLIC_URL}/assets/${nameIMG}.png`;
  
  return (
    <div className="h-[100%] content-center">
      <img
        src={image}
        style={{ height: "50px", margin: "auto" }}
        title={nameIMG}
        alt={nameIMG}
        onError={(e) => {
          console.log(`Изображение ${nameIMG} не найдено`);
          e.target.style.display = 'none';
          // Можно добавить fallback изображение или показать первую букву имени
          e.target.parentNode.innerHTML = nameIMG.charAt(0).toUpperCase();
        }}
      />
    </div>
  );
}; 